module.exports = __webpack_public_path__ + "static/media/bamboo.19bb902c.webp";